/* eslint-disable no-fallthrough */
import * as Actions from '../actions'
import * as ActionTypes from '../actionTypes'
import type { ResourceInfo } from '@src/endpoints/services/base.service'
import type { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { getResourceTypesAction } from '../actions/shell.actions'
import { ENABLE_SSO } from '@src/endpoints/oauth'

export interface ResourceType extends ResourceInfo {
  display_name_plural?: string
}

export type ResourceTypeDict = { [key in ResourceTypeEnum]?: ResourceType }

// Reducer
export const defaultState = {
  isPendingResourceTypes: false as boolean,
  enabledSSO: ENABLE_SSO,
  resourceTypes: {} as ResourceTypeDict,
  useIDNLoginPath: false,
  useTexBoxTooltipFix: false
}

export type ShellState = typeof defaultState

type GeneratedActionTypes = PayloadAction<
  {
    isPending?: boolean
    flag?: boolean
    useIDNLoginPath?: boolean
    useTexBoxTooltipFix?: boolean
  },
  string
>

type ActionTypes = Actions.ActionTypes | GeneratedActionTypes

export function reducer(state = defaultState, action: ActionTypes): ShellState {
  switch (action.type) {
    case ActionTypes.Shell.SET_USE_IDN_PATH_FLAG: {
      return {
        ...state,
        useIDNLoginPath: action.payload.useIDNLoginPath
      }
    }
    case ActionTypes.Shell.SET_STATUS_SSO: {
      return {
        ...state,
        enabledSSO: action.payload.flag
      }
    }
    case ActionTypes.Shell.CLEANER_SUPPORTED_RESOURCE_TYPES: {
      return {
        ...state,
        resourceTypes: defaultState.resourceTypes
      }
    }
    case ActionTypes.Shell.GET_SUPPORTED_RESOURCE_TYPES_SUCCESS: {
      return {
        ...state,
        resourceTypes: (action as getResourceTypesAction).payload.types,
        isPendingResourceTypes: action.payload.isPending
      }
    }
    case ActionTypes.Shell.SET_TEXTBOX_TOOLTIP_FIX_FLAG: {
      return {
        ...state,
        useTexBoxTooltipFix: action.payload.useTexBoxTooltipFix
      }
    }

    default: {
      return state
    }
  }
}
